// Resolves the receipt date for a review entry: prefer the ai-entries item's own entryDate,
// then fall back to the file uploadedAt so automatched items without an explicit date still
// prefill a value. Shared by `flattenReviewEntriesToTableRows` (which feeds the detail form via
// `entry.date`) and the bulk validate payload builder so both stay in sync.
export const getReviewEntryReceiptDate = (
  entryDate: string | undefined,
  uploadedAt: string | undefined,
): string | undefined => entryDate ?? uploadedAt
